<div class="">
  <div class="flex gap-2">
    @for (group of orderedAvailability(); track $index) {
      <div [attr.data-type]="group.type" class="w-12">
        @if (group.data.available) {
          @switch (group.type) {
            @case ('local') {
              <app-results-table-row-availability-badge-local class="item-local" [data]="group.data" [price]="price()"/>
            }
            @case ('transfer') {
              <app-results-table-row-availability-badge-transfer class="item-transfer" [data]="group.data" [price]="price()"/>
            }
            @case ('distributor') {
              <app-results-table-row-availability-badge-distributor class="item-distributor" [data]="group.data" [price]="price()"/>
            }
          }
        }
      </div>
    }
  </div>
</div>
